// const api = {api
//     Login: '/sys/login',
//     Logout: '/sys/logout',
//     ForgePassword: '/auth/forge-password',
//     Register: '/auth/register',
//     SendSms: '/account/sms',
//     // get my info
//     UserInfo: '/user/info',
//     backtrackingInfo: '/f/api/punchClock/backtrackingInfo'
// }
module.exports = {
    //通过code获取用户openID
    getUserOpenid: '/wisdom/customUser/api/getUserOpenid',
    //绑定手机号
    bindPhone: '/wisdom/customUser/api/bindPhone',
    //获取验证码
    getSmsCaptcha: '/wisdom/customUser/api/getAuthCodeForCast',
    //退出登录
    loginOut: '/wisdom/customUser/api/loginOut',
    //获取用户信息
    getUserInfo: '/wisdom/customUser/api/getUserInfo',
    //查询客户发货详情
    getStoreShipping: '/wisdom/storeCustomer/api/getStoreShipping',
    //获取库存物流记录信息
    getStoreRecord: '/wisdom/storeCustomer/api/getStoreRecord',
    //获取实时库存
    getStoreShippingReal: '/wisdom/storeCustomer/api/getStoreShippingReal',
    //库存记录列表
    findStoreShippingList: '/wisdom/storeCustomer/api/findStoreShippingList',
    //修改物流灯状态
    changeState: '/wisdom/storeCustomer/api/changeState',
    //员工返程信息
    backtrackingInfo: '/f/api/punchClock/backtrackingInfo',
    //返程信息详情
    backtrackingInfoDetail: '/f/api/punchClock/backtrackingInfoDetail',
    //返程信息等级
    backtrackingInfoRegister: '/f/api/punchClock/backtrackingInfoRegister',
    //员工体温信息
    staffTemperatureInfo: '/f/api/punchClock/staffTemperatureInfo',
    //员工体温打卡
    staffPunchClock: '/f/api/punchClock/staffPunchClock',
    //打卡记录
    queryStaffPunchClock: '/f/api/punchClock/queryStaffPunchClock',
    //企业入驻
    enterpriseCheckIn: '/f/api/punchClock/enterpriseCheckIn',
    //企业登录
    enterpriseLogin: '/f/api/punchClock/enterpriseLogin',
    //员工注册
    staffRegister: '/f/api/punchClock/staffRegister',
    //员工绑定
    staffCheckIn: '/f/api/punchClock/staffCheckIn',
    //员工登录
    satffLogin: '/f/api/punchClock/satffLogin',
    //员工查询信息登记详情
    backtrackingPersonalInfo: '/f/api/punchClock/backtrackingPersonalInfo',
    //查询捐款信息
    punchClockContributionMoney: '/f/api/punchClock/punchClockContributionMoney',
    //面试登记
    hpInterviewRegister: '/f/api/hpinterview/register',
    getCompanyStatus: '/f/api/hpinterview/getCompanyStatus',
    // 验证签到
    getIntentCompany: '/f/api/qdCheckIns/getIntentCompany',
    // 人才签到登记保存
    checkIns: '/f/api/qdCheckIns/checkIns',
    // 获取验证码
    getCaptchaCode: '/f/api/login/getCaptchaCode',
};
